import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Homepage from './Pages/Homepage/Homepage';
import About from './Pages/About/About';
import Contact from './Pages/Contact/Contact.jsx';
import EssenceDetail from './Pages/EssenceDetail/EssenceDetail.jsx';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/essence/:id" element={<EssenceDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
